/* eslint-disable no-console */
import { pdfjs } from "react-pdf";

// Set worker source synchronously to avoid race conditions
// Use CDN as default - it's reliable and avoids version mismatch issues
const cdnWorkerUrl = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
pdfjs.GlobalWorkerOptions.workerSrc = cdnWorkerUrl;

// Optionally upgrade to local worker if available (non-blocking)
const tryLocalWorker = async () => {
  const isDevelopment = import.meta.env.DEV;
  const localWorkerPath = isDevelopment
    ? `/pdf.worker.min.mjs?v=${Date.now()}`
    : "/pdf.worker.min.mjs";

  try {
    const testResponse = await fetch(localWorkerPath, { method: "HEAD" });
    if (testResponse.ok) {
      pdfjs.GlobalWorkerOptions.workerSrc = localWorkerPath;
    }
  } catch {
    // Keep using CDN, no action needed
  }
};

// Try to use local worker but don't block on it
tryLocalWorker();
